<p-toast key="main" />
<p-confirmDialog />
<div class="px-6 py-4">
  <div class="flex justify-content-between mb-4">
    <p class="text-xl font-semibold">{{ 'layout.configurations.offshoreLevel.title' | translate }}</p>
    <p-button
      *emPermission="Permission.CONFIG_STAFFING"
      class="p-button-success"
      icon="pi pi-plus"
      severity="success"
      (onClick)="onAdd()"></p-button>
  </div>
  <p-table
    [value]="offshoreLevels"
    [paginator]="true"
    [rows]="10"
    [rowsPerPageOptions]="[10, 20, 50, 100]"
    paginatorPosition="bottom"
    paginatorAlignment="center"
    styleClass="w-full p-datatable-sm">
    <ng-template pTemplate="header">
      <tr>
        <th scope="col" pSortableColumn="level" class="bg-white">
          {{ 'layout.configurations.offshoreLevel.level' | translate }} <p-sortIcon field="level" />
        </th>
        <th scope="col" pSortableColumn="denomination" class="bg-white">
          {{ 'layout.configurations.offshoreLevel.label.DenominationEn' | translate }}
          <p-sortIcon field="denomination" />
        </th>
        <th scope="col" pSortableColumn="denominationEs" class="bg-white">
          {{ 'layout.configurations.offshoreLevel.label.DenominationEs' | translate }}
          <p-sortIcon field="denominationEs" />
        </th>
        <th scope="col" pSortableColumn="denominationAr" class="bg-white">
          {{ 'layout.configurations.offshoreLevel.label.DenominationAr' | translate }}
          <p-sortIcon field="denominationAr" />
        </th>
        <th scope="col" pSortableColumn="countsAsOffshore" class="bg-white">
          {{ 'layout.configurations.offshoreLevel.countAsOffshore' | translate }}
          <p-sortIcon field="countsAsOffshore" />
        </th>
        <th scope="col" pSortableColumn="definition" class="bg-white">
          {{ 'layout.configurations.offshoreLevel.label.DefinitionEn' | translate }} <p-sortIcon field="definition" />
        </th>
        <th scope="col" pSortableColumn="definitionEs" class="bg-white">
          {{ 'layout.configurations.offshoreLevel.label.DefinitionEs' | translate }} <p-sortIcon field="definitionEs" />
        </th>
        <th scope="col" pSortableColumn="definitionAr" class="bg-white">
          {{ 'layout.configurations.offshoreLevel.label.DefinitionAr' | translate }} <p-sortIcon field="definitionAr" />
        </th>
        <th *emPermission="Permission.CONFIG_STAFFING" scope="col" class="bg-white w-10rem pl-3">
          {{ 'layout.configurations.offshoreLevel.actions' | translate }}
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-offshoreLevel>
      <tr>
        <td>{{ offshoreLevel.level }}</td>
        <td>{{ offshoreLevel.denomination }}</td>
        <td>{{ offshoreLevel.denominationEs }}</td>
        <td>{{ offshoreLevel.denominationAr }}</td>
        <td>
          <p-tag
            [value]="getTranslatedValue(offshoreLevel.countsAsOffshore)"
            [severity]="offshoreLevel.countsAsOffshore ? 'success' : 'danger'"></p-tag>
        </td>
        <td>{{ truncate(offshoreLevel.definition) }}</td>
        <td>{{ truncate(offshoreLevel.definitionEs) }}</td>
        <td>{{ truncate(offshoreLevel.definitionAr) }}</td>
        <ng-container *emPermission="Permission.CONFIG_STAFFING">
          <td class="px-4 py-2 flex flex-row-reverse flex-wrap gap-2">
            <p-button icon="pi pi-eye" severity="info" [outlined]="true" (onClick)="onView(offshoreLevel)"> </p-button>
            <ng-container *emPermission="Permission.CONFIGURATION_WRITE">
              <p-button icon="pi pi-pencil" [outlined]="true" class="mr-2" (onClick)="onEdit(offshoreLevel)"></p-button>
              <p-button
                icon="pi pi-trash"
                severity="danger"
                [outlined]="true"
                (onClick)="onDelete($event, offshoreLevel.id)"></p-button>
            </ng-container>
          </td>
        </ng-container>
      </tr>
    </ng-template>
  </p-table>
</div>
